<template>
  <section class="self-center" data-test-id="review-snapshot-fit-rating">
    <div class="m-a lg:max-w-84 space-y-4">
      <div v-for="(type, i) in fitRatings" :key="i" class="space-y-1">
        <p :id="`fit-rating-${i}`" class="subtitle-4">
          {{ type.name }}
        </p>
        <vf-progress-bar
          v-if="type.display_values?.length"
          :aria-labelledby="`fit-rating-${i}`"
          :aria-valuetext="getFitRatingValues(type).label"
          class="w-full rounded-xl"
          data-test-id="review-snapshot-fit-rating-scale"
          :max="type.display_values.length"
          :value="getFitRatingValues(type).value"
        />
        <div class="body-5 flex between">
          <span>{{ type.display_values?.[0] }}</span>
          <span>{{ type.display_values?.[type.display_values.length - 1] }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { ProductReviewsRollupProperty } from '#root/api/clients/product/data-contracts'

defineProps<{
  fitRatings: ProductReviewsRollupProperty[]
}>()
</script>
